import './index.css';
import { jsx } from 'react/jsx-runtime';
import { useRef, useState, useMemo } from 'react';
import { AsyncDataContext } from './AsyncDataContext.js';

const makeKey = (startDate, endDate) => {
    return `${new Date(startDate).getTime()}-${new Date(endDate).getTime()}`;
};
/**
 * Хранит данные, загруженные всеми вложенными AsyncDataLoader-ами, и предоставляет методы для загрузки данных
 */
const AsyncDataStore = ({ children, disabledDatesFunc, parallelLoadersLimit = null, }) => {
    const asyncDataState = useRef({});
    const [disabledDates, setDisabledDates] = useState([]);
    const value = useMemo(() => {
        if (!disabledDatesFunc) {
            return null;
        }
        return {
            disabledDates,
            hasAsyncFunc: true,
            hasData: (startDate, endDate) => makeKey(startDate, endDate) in asyncDataState.current,
            startAsyncLoading: () => void 0,
            awaitAsyncLoading: (startDate, endDate) => {
                const key = makeKey(startDate, endDate);
                if (!(key in asyncDataState.current)) {
                    asyncDataState.current[key] = {
                        promise: new Promise(async (resolve) => {
                            try {
                                const _disabledDates = await disabledDatesFunc(startDate, endDate);
                                setDisabledDates((disabledDates) => [...disabledDates, ..._disabledDates]);
                            }
                            finally {
                                asyncDataState.current[key].state = 'done';
                                resolve();
                            }
                        }),
                        state: 'loading',
                    };
                }
                return asyncDataState.current[key].promise;
            },
            isLoading: () => Object.values(asyncDataState.current).some(({ state }) => state === 'loading'),
            isLimitExceeded: () => parallelLoadersLimit !== null &&
                Object.values(asyncDataState.current).filter(({ state }) => state === 'loading').length >=
                    parallelLoadersLimit,
        };
    }, [disabledDates, disabledDatesFunc, setDisabledDates, parallelLoadersLimit]);
    return jsx(AsyncDataContext.Provider, { value: value, children: children });
};

export { AsyncDataStore };
//# sourceMappingURL=AsyncDataStore.js.map
